import React from 'react';
import { Animation } from './Animation';
export var assetsUrl = 'https://assets.asurion-ui.my.asurion53.com';
var data = {
    '404': {
        title: 'This page is missing',
        subtitle: "It may have been moved or deleted.\n But don't worry, we can fix almost anything.",
        actionLabel: 'Go to homepage',
        illustration: (React.createElement(Animation, { animationSrc: "".concat(assetsUrl, "/images/illustrations/error/404-animation/"), animationFrames: 12, transitionDuration: 250, errorNumberSrc: "".concat(assetsUrl, "/images/illustrations/error/code/404.svg"), imageSrc: "".concat(assetsUrl, "/images/phone.png"), imgAfterIdx: 7, altText: "404" }))
    }
};
export default data;
